<template>
  <div class="homepage">
    <div class="hero">
      <Hero
        title="We love your Porsche<br/>as much as you do."
        image="Home_Header"
        extension="jpg"
        :isStatic="false"
      ></Hero>
    </div>
    <div class="below-hero">
      <div class="container">
        <div class="columns">
          <div class="column below-hero-column-left is-three-fifths">
            <h1 class="title">
              Discover the power of insurance backed by the Porsche name.
            </h1>
            <Innovation></Innovation>
          </div>
          <div class="column" id="home-page-section">
            <Quote
              title="Auto coverage created for Porsche drivers."
              subtitle="
                You will need your <span class='is-bold'>drivers license number</span> and <span class='is-bold'>VIN</span>
                <i class='icon icon--info tool-tip'>
                  <div class='content'>
                    <p>
                      Your 17-character Vehicle Identification Number (VIN) can be found at the base of your windshield on the driver’s side, on the driver’s side door jamb, or on your vehicle registration or insurance card. Note: the VIN will never include the letters “I”, “O”, or “Q”.
                    </p>
                    <i></i>
                  </div>
                </i>
              "
              :showState="true"
            ></Quote>
          </div>
        </div>
      </div>
    </div>
    <VideoSection></VideoSection>
    <HomeAccordion id="exploring-benefits"></HomeAccordion>
    <TwoSection class="bottom">
      <section class="page-section">
        <div class="container quote-container">
          <div
            :class="{
              columns: true
            }"
          >
            <div
              :class="{
                column: true,
                'first-section': true,
                'is-half-desktop': true
              }"
            >
              <h1 class="title" style="margin:0">
                Auto coverage created for Porsche drivers.
              </h1>
              <p class="is-paddingless" style="margin:0">
                Get a quote:
                <a
                  style="text-decoration:underline;"
                  :href="'tel:1-' + $phoneNumber"
                  >1-{{ $phoneNumber }}</a
                >
              </p>
              <ThirdQuote
                subtitle="You will need your <span class='is-bold'>drivers license number</span> and <span class='is-bold'>VIN</span>
                <i class='icon icon--info tool-tip'>
                  <div class='content'>
                    <p>
                      Your 17-character Vehicle Identification Number (VIN) can be found at the base of your windshield on the driver’s side, on the driver’s side door jamb, or on your vehicle registration or insurance card. Note: the VIN will never include the letters “I”, “O”, or “Q”.
                    </p>
                    <i></i>
                  </div>
                </i>"
                :showState="true"
                :showNumber="true"
              ></ThirdQuote>
            </div>
            <div
              :class="{
                column: true,
                'second-section': true,
                'is-half-desktop': true,
                'yellow-porsche': true
              }"
            ></div>
          </div>
        </div>
      </section>
    </TwoSection>
    <TwoSection id="designed-for-you">
      <section class="page-section">
        <div class="container">
          <div class="columns split-section porsche-radius__large">
            <div class="column first-section is-two-fifths-desktop">
              <h1 class="title">Why select Porsche Auto Insurance?</h1>
              <p class="tertiary-title">
                Our <span style="white-space: nowrap;">Porsche</span> expertise
                comes from knowing—and loving—your vehicle better than any
                other insurer. Gain the confidence of having your Porsche in the
                hands of true experts.
              </p>
            </div>
            <div
              class="column second-section porsche-radius__large porsche is-three-fifths-desktop second"
            >
              <picture>
                <source
                  srcset="https://static.porscheautoinsurance.com/images/homepage/PAI_Landing-Page_Desktop_18.jpg"
                  width="1920"
                  height="1080"
                />
                <img
                  src="https://static.porscheautoinsurance.com/images/homepage/PAI_Landing-Page_Desktop_18.jpg"
                  alt=""
                />
              </picture>
            </div>
          </div>
        </div>
      </section>
    </TwoSection>
    <CustomerQuotes :screenSize="screenSize"></CustomerQuotes>
    <TwoSection id="stay-connected">
      <section class="page-section">
        <div class="container">
          <div
            class="columns split-section porsche-radius__large"
            :style="{
              color: '#fff',
              'background-color': '#010205'
            }"
          >
            <div class="column first-section is-two-fifths-desktop">
              <h1
                class="title"
                :style="{
                  color: '#fff'
                }"
              >
                Stay Connected with Porsche Auto Insurance
              </h1>
              <p class="tertiary-title">
                By signing up to receive emails from
                <span style="white-space: nowrap;">Porsche</span> Auto
                Insurance, you will stay up-to-date on the latest news, coverage
                expansion, policy options, and messages from the insurers who
                love your Porsche as much as you do.
              </p>
              <div class="button-group">
                <button
                  type="submit"
                  class="button-primary button-primary--white -spacing-static-f is-pulled-left"
                  @click="$router.push('/stay-connected')"
                >
                  <span
                    class="button-primary__icon icon icon--arrow-right-hair"
                  >
                    <span class="loader-base button-primary__loader"></span>
                  </span>

                  <span class="button-primary__label">Join the list</span>
                </button>
              </div>
            </div>
            <div class="column second-section is-three-fifths-desktop contact">
              <picture>
                <source
                  media="(max-width: 479px)"
                  srcset="
                    https://images-porsche.imgix.net/-/media/267719B1C04D444885DCA9EB0C003507_4F16D36E90B342589751A40A73986C1C_4-3_dealer_search_new?iar=0&w=407&ar=4%3A3&q=85&auto=format       1x,
                    https://images-porsche.imgix.net/-/media/267719B1C04D444885DCA9EB0C003507_4F16D36E90B342589751A40A73986C1C_4-3_dealer_search_new?iar=0&w=407&ar=4%3A3&q=45&dpr=2&auto=format 2x
                  "
                  width="1200"
                  height="900"
                />
                <source
                  media="(max-width: 759px)"
                  srcset="
                    https://images-porsche.imgix.net/-/media/F3D689BF517843DF9F9E79F5AFD86008_0D6016CEDC714793879B0E14411AB9C1_16-9_dealer_search_new?iar=0&w=645&ar=16%3A9&q=85&auto=format       1x,
                    https://images-porsche.imgix.net/-/media/F3D689BF517843DF9F9E79F5AFD86008_0D6016CEDC714793879B0E14411AB9C1_16-9_dealer_search_new?iar=0&w=645&ar=16%3A9&q=45&dpr=2&auto=format 2x
                  "
                  width="1920"
                  height="1080"
                />
                <source
                  media="(max-width: 999px)"
                  srcset="
                    https://images-porsche.imgix.net/-/media/F3D689BF517843DF9F9E79F5AFD86008_0D6016CEDC714793879B0E14411AB9C1_16-9_dealer_search_new?iar=0&w=819&ar=16%3A9&q=85&auto=format       1x,
                    https://images-porsche.imgix.net/-/media/F3D689BF517843DF9F9E79F5AFD86008_0D6016CEDC714793879B0E14411AB9C1_16-9_dealer_search_new?iar=0&w=819&ar=16%3A9&q=45&dpr=2&auto=format 2x
                  "
                  width="1920"
                  height="1080"
                />
                <source
                  media="(max-width: 1299px)"
                  srcset="
                    https://images-porsche.imgix.net/-/media/267719B1C04D444885DCA9EB0C003507_4F16D36E90B342589751A40A73986C1C_4-3_dealer_search_new?iar=0&w=598&ar=4%3A3&q=85&auto=format       1x,
                    https://images-porsche.imgix.net/-/media/267719B1C04D444885DCA9EB0C003507_4F16D36E90B342589751A40A73986C1C_4-3_dealer_search_new?iar=0&w=598&ar=4%3A3&q=45&dpr=2&auto=format 2x
                  "
                  width="1200"
                  height="900"
                />
                <source
                  media="(max-width: 1759px)"
                  srcset="
                    https://images-porsche.imgix.net/-/media/F3D689BF517843DF9F9E79F5AFD86008_0D6016CEDC714793879B0E14411AB9C1_16-9_dealer_search_new?iar=0&w=792&ar=16%3A9&q=85&auto=format       1x,
                    https://images-porsche.imgix.net/-/media/F3D689BF517843DF9F9E79F5AFD86008_0D6016CEDC714793879B0E14411AB9C1_16-9_dealer_search_new?iar=0&w=792&ar=16%3A9&q=45&dpr=2&auto=format 2x
                  "
                  width="1920"
                  height="1080"
                />
                <source
                  media="(max-width: 1919px)"
                  srcset="
                    https://images-porsche.imgix.net/-/media/F3D689BF517843DF9F9E79F5AFD86008_0D6016CEDC714793879B0E14411AB9C1_16-9_dealer_search_new?iar=0&w=865&ar=16%3A9&q=85&auto=format       1x,
                    https://images-porsche.imgix.net/-/media/F3D689BF517843DF9F9E79F5AFD86008_0D6016CEDC714793879B0E14411AB9C1_16-9_dealer_search_new?iar=0&w=865&ar=16%3A9&q=45&dpr=2&auto=format 2x
                  "
                  width="1920"
                  height="1080"
                />
                <source
                  media="(min-width: 1920px)"
                  srcset="
                    https://images-porsche.imgix.net/-/media/F3D689BF517843DF9F9E79F5AFD86008_0D6016CEDC714793879B0E14411AB9C1_16-9_dealer_search_new?iar=0&w=865&ar=16%3A9&q=85&auto=format       1x,
                    https://images-porsche.imgix.net/-/media/F3D689BF517843DF9F9E79F5AFD86008_0D6016CEDC714793879B0E14411AB9C1_16-9_dealer_search_new?iar=0&w=865&ar=16%3A9&q=45&dpr=2&auto=format 2x
                  "
                  width="1920"
                  height="1080"
                />
                <img
                  src="https://images-porsche.imgix.net/-/media/F3D689BF517843DF9F9E79F5AFD86008_0D6016CEDC714793879B0E14411AB9C1_16-9_dealer_search_new?iar=0&w=1759&ar=16%3A9&q=85&auto=format"
                  width="1920"
                  height="1080"
                  alt="A smiling woman looking back holding hands and carrying a dog in a leash in front of a Porsche Center."
                  class="PcomPicture__root__18b61 PcomPicture__fit-cover__18b61 PcomPicture__layout-fit-container__18b61"
                  fetchpriority="auto"
                  loading="lazy"
                />
              </picture>
            </div>
          </div>
        </div>
      </section>
    </TwoSection>
    <!--    <Faq id="faq"></Faq>-->
    <TwoSection class="bottom">
      <section class="page-section">
        <div class="container quote-container">
          <div
            :class="{
              columns: true,
              'final-section': true
            }"
          >
            <div
              :class="{
                column: true,
                final: true,
                'first-section': true,
                'is-half-desktop': true
              }"
            >
              <h1 class="title">Auto coverage created for Porsche drivers.</h1>
              <p class="is-paddingless" style="margin:0">
                Get a quote:
                <a
                  style="text-decoration:underline;"
                  :href="'tel:1-' + $phoneNumber"
                  >1-{{ $phoneNumber }}</a
                >
              </p>
              <ThirdQuote
                subtitle="You will need your <span class='is-bold'>drivers license number</span> and <span class='is-bold'>VIN</span>
                <i class='icon icon--info tool-tip'>
                  <div class='content'>
                    <p>
                      Your 17-character Vehicle Identification Number (VIN) can be found at the base of your windshield on the driver’s side, on the driver’s side door jamb, or on your vehicle registration or insurance card. Note: the VIN will never include the letters “I”, “O”, or “Q”.
                    </p>
                    <i></i>
                  </div>
                </i>"
                :showState="true"
                :showNumber="true"
              ></ThirdQuote>
            </div>
            <div
              :class="{
                column: true,
                'second-section': true,
                'is-half-desktop': true,
                third: true
              }"
            >
              <picture>
                <source
                  srcset="https://static.porscheautoinsurance.com/images/homepage/youth-driveway.jpg"
                  width="1920"
                  height="1080"
                />
                <img
                  src="https://static.porscheautoinsurance.com/images/homepage/youth-driveway.jpg"
                  alt=""
                />
              </picture>
            </div>
          </div>
        </div>
      </section>
    </TwoSection>
    <ContactUs id="contact-us"></ContactUs>
  </div>
</template>
<script>
import Hero from '../components/shared/Hero';
import Innovation from '../components/homepage/Innovation';
import Quote from '../components/homepage/Quote';
import VideoSection from '@/components/shared/VideoSection';
import TwoSection from '@/components/homepage/TwoSection';
import QuoteWide from '@/components/homepage/QuoteWide';
import ThirdQuote from '@/components/homepage/ThirdQuote';
import CustomerQuotes from '@/components/homepage/CustomerQuotes';
import Faq from '@/components/homepage/Faq';
import ContactUs from '@/components/homepage/ContactUs';
import HomeAccordion from '@/components/homepage/HomeAccordion.vue';

export default {
  name: 'HomePage',
  components: {
    HomeAccordion,
    ContactUs,
    Faq,
    CustomerQuotes,
    QuoteWide,
    ThirdQuote,
    TwoSection,
    VideoSection,
    Hero,
    Innovation,
    Quote
  },
  mounted() {
    let pathName = window.location.pathname;
    if (pathName === '/search-for-my-quote') {
      setTimeout(() => {
        this.$scrollTo('#home-page-section', 700, { easing: 'linear' });
      }, 50);
    }
    this.FLOOD();
  },
  computed: {
    screenSize() {
      return this.$mq.media;
    }
  },
  methods: {
    FLOOD() {
      // USA_Porsche_DCM_Floodlight_PAI_Homepage_PageLoad
      if (
        process.env.VUE_APP_ENV.toLowerCase() !== 'production' &&
        process.env.VUE_APP_ENV.toLowerCase() !== 'prod'
      ) {
        return;
      }
      // console.log('Floodlight Active');
      let axel = Math.random() + '';
      let a = axel * 10000000000000;
      let flDiv = document.body.appendChild(document.createElement('div'));
      let GDPR = '${GDPR}';
      let GDPR_CONSENT_755 = '${GDPR_CONSENT_755}';
      flDiv.setAttribute('id', process.env.VUE_APP_FLOODLIGHT_ID);
      flDiv.style.position = 'absolute';
      flDiv.style.top = '0';
      flDiv.style.left = '0';
      flDiv.style.width = '1px';
      flDiv.style.height = '1px';
      flDiv.style.display = 'none';
      flDiv.innerHTML = `<iframe id=${process.env.VUE_APP_FLOODLIGHT_ID +
        '_FLIframe2'} src="https://5368208.fls.doubleclick.net/activityi;src=5368208;type=porsc00c;cat=usa_p0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=${a}?" width="1" height="1" frameborder="0"></iframe>`;
    }
  },
  data: () => ({})
};
</script>
<style lang="scss">
.quote-select.v-select .dropdown-toggle {
  color: $white !important;
  border: none !important;
}
div#faq,
div#contact-us {
  background-color: $porcelain;
}
div.carousel-pane {
  filter: drop-shadow(0 0.125rem 0.25rem $grey-light);
}
h1.title {
  font-family: $family-sans-serif;
  font-weight: bold;
  font-size: clamp(1.27rem, calc(1.16rem + 0.51vw), 1.78rem);
  line-height: 1.25em;
}

.button-group {
  max-width: fit-content;
}

.tertiary-title {
  font-family: $family-sans-serif;
  font-size: 1rem;
  line-height: 1.5rem;
  margin: 0;
}

span.highlight {
  background-color: yellow;
}
.tool-tip {
  .content {
    filter: drop-shadow(0 0.125rem 0.25rem $grey);
  }
}
</style>
<style lang="scss" scoped>
p,
li {
  font-size: 16px;
  line-height: 24px;
}
.more-about {
  background-color: $white;
  padding: 30px 0;

  .footer-heading {
    font-size: 30px;
    font-family: $family-sans-serif-bold;
    margin: 0 0 0.4375em 2%;
  }

  .link-list {
    text-align: left;
    margin-left: 2%;
  }

  a {
    display: inline-block;
    padding-right: 0.875em;
    text-decoration: none;

    ::before {
      border-left: 1px solid #c8cacb;
      padding-right: 0.875em;
      content: '';
      height: 1em;
    }

    &:first-child {
      ::before {
        padding-right: 0;
        border-left: none;
      }
    }
  }
}
.columns {
  margin: 2rem 0;

  &.final-section,
  &.split-section {
    margin: 0;
  }
}

.below-hero-column-left {
  padding-left: 0;

  @media (min-width: 760px) {
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
    width: 55%;
  }
}

.below-hero {
  padding-bottom: $--pcom-spacing-large;
  min-height: unset;
}

.padding-needed {
  padding: 0 2%;

  @media (max-width: 780px) {
    padding: 0;
  }
}

.desktop-br {
  @media (min-width: 1000px) {
    display: block;
  }
}
</style>
